<template>
  <form-page-template
      :dirty="dirty"
      @save="doSave"
      maximizable>
    <template #toolbar-items>
<!--      <edit-toggle-button-->
<!--          component-name="DataComponentModel"-->
<!--          v-if="!isCategory2nd('external')">-->
<!--      </edit-toggle-button>-->
      <v-toolbar-title class="with-divider">
        {{ dictionary.name }} - {{ dataComponentModel.name }}
      </v-toolbar-title>
    </template>

    <template>
      <v-row dense>
        <v-col cols="12" md="2">
          <hds-id-field
              :value="dataComponentModel.id"
              label="ID"
              hide-details/>
        </v-col>
        <v-col cols="12" md="10">
          <v-text-field
              v-if="isEditable"
              v-model="dataComponentModel.name"
              label="データ構成モデル名"
              :readonly="!isEditable"
              :rules="[v => !!v || 'データ構成モデル名が必要です']"
              autofocus>
          </v-text-field>
          <text-field-like
              v-else
              :value="dataComponentModel.name"
              label="データ構成モデル名"
              hide-details>
          </text-field-like>
        </v-col>
        <v-col cols="12" v-if="isCategory2nd('common')">
          <category-select
              v-model="dataComponentCategoryIds"
              :return-object="false"
              label="カテゴリ"
              :readonly="!isEditable"
              :hide-details="!isEditable"
              placeholder="未選択"
              required
              multiple
              chips small-chips>
          </category-select>
        </v-col>
        <v-col cols="12">
          <v-textarea
              v-if="isEditable"
              v-model="dataComponentModel.description"
              label="説明"
              messages="複数行入力可"
              rows="1"
              auto-grow
              required>
          </v-textarea>
          <text-field-like
              v-else
              :value="dataComponentModel.description"
              label="説明"
              placeholder="未設定"
              hide-details
              multi-line>
          </text-field-like>
        </v-col>
      </v-row>
    </template>

    <!-- 参照先共通辞書 -->
    <template #after-form v-if="!isCategory2nd('common')">
      <v-container>
        <v-card outlined>
          <v-card-title style="padding-bottom: 0;">共通辞書</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="4" md="2">
                <hds-id-field
                    :value="selectedDictionary.id"
                    label="共通辞書ID"
                    hide-details
                ></hds-id-field>
              </v-col>
              <v-col cols="8" md="3">
                <text-field-like
                    label="共通辞書名"
                    :value="selectedDictionary.name"
                    hide-details>
                  <template #default="{value}">
                    <deletable-field :value="value" :deleted="selectedDictionary.isDeleted"/>
                  </template>
                </text-field-like>
              </v-col>
              <v-col cols="4" md="3">
                <hds-id-field
                    :value="selectedDataComponentModel.id"
                    label="選択されているデータ構成モデルID"
                    hide-details
                ></hds-id-field>
              </v-col>
              <v-col cols="8" md="4">
                <text-field-like
                    :value="selectedDataComponentModel.name"
                    label="選択されているデータ構成モデル名"
                    hide-details
                ></text-field-like>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
    </template>

    <template #tab-items>
      <v-tab :to="{...$route, name: alterRouteName('./dataPropertyDefinitions')}">
        <span>データ項目定義</span>
        <error-icon small :level="errorLevels.dataPropertyDefinition"></error-icon>
      </v-tab>

      <template v-if="isCategory2nd('common')">
        <v-tab :to="{...$route, name: alterRouteName('./dataRelationModels')}"
               class="data-relation-list">
          データ連結モデル
        </v-tab>
      </template>

      <template v-else>
        <v-tab :to="{...$route, name: alterRouteName('./extendedDataPropertyDefinitions')}">
          共通辞書データ項目拡張
        </v-tab>
      </template>

      <v-tab :to="{...$route, name: alterRouteName('./processOperations')}">
        プロセス手順定義
      </v-tab>
    </template>

    <template #after-tabs>
      <router-view
          :dictionary="dictionary"
          :data-component-model="dataComponentModel"
          :selected-dictionary="selectedDictionary"
          :selected-data-component-model="selectedDataComponentModel"
          @change-error-level="handleErrorLevelChange"
          @dirty="markDirty">
      </router-view>
    </template>
  </form-page-template>
</template>

<script>
import Vue from "vue";
import PathInfoMixin from "@/router/PathInfoMixin";
import {IoableParentPageMixin} from "@/router/IoablePageMixin";
import CategorySelect from "@/components/molecules/CategorySelect.vue";
import BetterSet from "betterset";
import HdsIdField from "@/components/molecules/HdsIdField.vue";
import {mapActions, mapGetters, mapMutations} from "vuex";
import query from "@/gql/DataComponentModel/Query.gql";
import queryCommonDictionaries from "@/gql/DataComponentModel/QueryCommonDictionaries.gql";
import mutation from "@/gql/DataComponentModel/Update.gql";
import FormPageTemplate from "@/components/templates/FormPageTemplate.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import DeletableField from "@/components/molecules/DeletableField.vue";
import ErrorIcon from "@/components/molecules/ErrorIcon.vue";
import {safeMeta} from "@/router/Meta";
import deepEquals from "fast-deep-equal";
import uniq from "array-uniq";

export default {
  name: 'DataComponentModel',
  components: {
    ErrorIcon,
    DeletableField,
    TextFieldLike, FormPageTemplate, HdsIdField, CategorySelect
  },
  mixins: [
    PathInfoMixin,
    IoableParentPageMixin.extend({
      beforeRouteUpdate(to, from, next) {
        next();
        if(to.hash !== from.hash ||
            !deepEquals(to.params, from.params)) {
          this.$nextTick(() => {
            this.doLoad();
          });
        }
      },
    }),
  ],
  props: {
    dictionaryId: String,
    dataComponentModelId: String
  },
  data() {
    return {
      valid: false,
      errorLevels: {
        dataPropertyDefinition: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      entities: 'hds/entities',
      client: 'hds/gqlClient',
      db: 'hds/db',
    }),
    dictionary() {
      return Vue.observable(
          this.entities.dictionary.findOne({id: this.dictionaryId})) || {id: this.dictionaryId};
    },
    dataComponentModel() {
      return Vue.observable(
          this.entities.dataComponentModel.findOne({id: this.dataComponentModelId})) || {id: this.dataComponentModelId};
    },
    dataComponentCategoryIds: {
      get() {
        return this.dataComponentModel.categoryIds || [];
      },
      set(newCategoryIds) {
        const prevSet = new BetterSet(this.dataComponentCategoryIds);
        const nextSet = new BetterSet(newCategoryIds);
        if (!prevSet.equals(nextSet)) {
          this.dataComponentModel.categoryIds = nextSet.asArray();
          this.markDirty();
        }
      }
    },
    selectedDataComponentModel() {
      const dataTranslationMap = this.entities.dataTranslationMap.findOne({'targetDictionary.id': this.selectedDictionaryId, parentId: null});
      if (dataTranslationMap) {
        return dataTranslationMap.targetDataComponentModel;
      } else {
        return {};
      }
    },
    selectedDictionary() {
      const dataTranslationMap = this.entities.dataTranslationMap.findOne({'targetDictionary.id': this.selectedDictionaryId, parentId: null});
      if (dataTranslationMap) {
        return dataTranslationMap.targetDictionary;
      } else {
        return {};
      }
    },
    selectedDictionaryId() {
      return this.$route.query?.selectedDictionary;
    },
    backButtonTo() {
      return {
        name: safeMeta(this.$route).parent,
        query: this.$route.query
      };
    },
  },
  methods: {
    ...mapMutations({
      showSnackbar: 'showSnackbar'
    }),
    ...mapActions({
      gqlQueryAndLoad: 'hds/gqlQueryAndLoad',
      gqlMutate: 'hds/gqlMutate'
    }),

    async load() {
      await this.gqlQueryAndLoad({
        clear: true,
        query,
        variables: {
          dictionaryId: this.dictionaryId,
          dataComponentModelId: this.dataComponentModelId
        },
        mapping: {
          dictionary: [
            'dictionary',
          ],
          category: 'dictionary.categories > id',
          dataComponentModel: [
            'dictionary.dataComponentModels > id*',
            'dataComponentModel.dataRelationModels.targetDataComponentModel *-',
          ],
          dataPropertyDefinition: [
            'dictionary.dataComponentModels.dataPropertyDefinitions > id*',
            'dataComponentModel.dataRelationModels.targetDataComponentModel.dataPropertyDefinitions > id*',
            'dataComponentModel.dataTranslationMaps.targetDataComponentModel.dataPropertyDefinitions*',
          ],
          dataRelation: [
            'dataComponentModel.dataRelationModels > id',
          ],
          dataPropertyRelation: 'dataComponentModel.dataRelationModels.dataPropertyRelationModels > id+',
          dataTranslationMap: 'dataComponentModel.dataTranslationMaps',
          dataPropertyTranslationMap: 'dataComponentModel.dataTranslationMaps.dataPropertyTranslationMaps',
          serviceComponentModel: 'dictionary.serviceComponentModels',
          processComponentModel: 'dictionary.serviceComponentModels.processComponentModels',
          processOperation: 'dictionary.serviceComponentModels.processComponentModels.processOperations'
        }
      });

      // 共通辞書の場合はここまでで OK
      if(this.isCategory2nd('common')) {
        return;
      }

      await this.gqlQueryAndLoad({
        clear: false,
        query: queryCommonDictionaries,
        variables: {
          dictionaryIds: uniq(this.entities.dataTranslationMap.find().map(dtm => dtm.targetDictionaryId))
        },
        mapping: {
          dataComponentModel: [
            'dictionaries.dataComponentModels*'
          ],
          dataPropertyDefinition: [
            'dictionaries.dataComponentModels.dataPropertyDefinitions*'
          ],
          dataRelation: [
            'dictionaries.dataRelationModels*',
          ],
        }
      });
    },
    save() {
      this.entities.dataComponentModel.update(this.dataComponentModel);
      const dcmDelta = this.entities.dataComponentModel.getDelta({
        update: [
          'id',
          'name', 'description', 'categoryIds'
        ]
      });
      const dpdDelta = this.entities.dataPropertyDefinition.getDelta({
        update: [
          'id',
          'dataComponentModelId', 'name', 'description', 'dataType',
          'isList', 'isRequired', 'isPrimaryKey', 'index', 'possibleValues'
        ]
      });
      const drmDelta = this.entities.dataRelation.getDelta({
        update: [
          'id', 'name',
          {
            name: 'dataPropertyRelationModels',
            source: row => this.entities.dataPropertyRelation
                .find({dataRelationModelId: row.id})
                .map(dpr => ({
                  sourceDataPropertyDefinitionId: dpr.sourceDataPropertyDefinitionId,
                  targetDataPropertyDefinitionId: dpr.targetDataPropertyDefinitionId
                }))
          }
        ]
      });
      const dptmDelta = this.entities.dataPropertyTranslationMap.getDelta({
        add: [
          'dataTranslationMapId', 'sourceDataPropertyDefinitionId', 'targetDataPropertyDefinitionId'
        ],
        remove: row => row.id
      });

      return this.gqlMutate({
        mutation,
        variables: {
          updateDataComponentModels: dcmDelta.update,
          updateDataPropertyDefinitions: dpdDelta.update,
          updateDataRelationModels: drmDelta.update,
          addDataPropertyTranslationMaps: dptmDelta.add,
          removeDataPropertyTranslationMaps: dptmDelta.remove
        }
      });
    },
    isTransitionPermitted(destination, route) {
      if(destination === 'edit') {
        const account = this.$store.getters['hcs/account'];
        if (!account.user || !account.owner) {
          return false;
        }
        return account.owner.id === this.dictionary.ownerId && !this.dictionary.isPublished;
      }
    },
    handleErrorLevelChange(e) {
      this.errorLevels[e.type] = e.level;
    },
  },
  watch: {
    dataComponentModel: {
      handler() {
        this.markDirty();
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
span.index {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  display: inline-block;
  vertical-align: middle;
  line-height: 50px;
  height: 50px;
}

$border-color: #888;

::v-deep {
  .el-table {
    .el-table__expanded-cell {
      padding: 10px 20px;
    }
  }
}

// タブの警告アイコンの左にマージン
.v-tab > *:nth-child(2) {
  margin-left: 0.2rem;
}
</style>
